import BannerSection from "./BannerSection";
import ProductList from "./ProductList";

const ProductPage = () => {
  return (
    <>
      <BannerSection />
      <ProductList />
    </>
  );
};

export default ProductPage;
